module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls col-md-offset-2"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                    \"paging\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"filtering\": {\r\n                                    \"enabled\": true\r\n                                    },\r\n                                    \"sorting\": {\r\n                                    \"enabled\": true\r\n                                    }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_reg_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payment Ref")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_txn_ref))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("RRR")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_payername))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Payer Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_payeremail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay RRR Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_amount))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay RRR Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_charges))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("CNpay Charges")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_cnpay_charges))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_total_paid_amt))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseId))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Remita Notify Response Message")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpayment.cnpay_rrr_notify_responseMessage))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v(" CNpay (Remita) ")]), _vm._v(" "), (_vm.cnpayments) ? _c('h3', [_vm._v(_vm._s(_vm.cnpayments.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         CNpay (Remita) Transactions \r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpayments), function(cnpayment, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_txn_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_rrr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_rrr_amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_total_paid_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpayment.cnpay_payername))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpayment)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                                    Payment Details\r\n                                    "), _c('a', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "href": "cnpaymentsremita"
    }
  }, [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-money-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("REF.")]), _vm._v(" "), _c('th', [_vm._v("RRR")]), _vm._v(" "), _c('th', [_vm._v("RRR Amount")]), _vm._v(" "), _c('th', [_vm._v("Total RRR Amount")]), _vm._v(" "), _c('th', [_vm._v("Payer")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c0f70e8"}!./src/components/CNpaymentsRemita/template.html
// module id = 159
// module chunks = 0